import React from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { label } from "../../config";

const DEFAULT_TITLE = label.DRUTAS_AGILE_TASK_MANAGEMENT;

/**
 * TitleManager component that manages the page title
 * It will show the default title when Helmet is not used in a component or when custom title is invalid
 * @author Muskan Thakur
 */
const TitleManager = ({ title, useDefaultTitle = false }) => {
  const { task } = useSelector((state) => state.taskSidebar);

  /** Helper function to check if a title is valid */
  const isValidTitle = (title) => {
    return title && typeof title === "string" && title.trim().length > 0;
  };

  /** Helper function to format the title with task ID and code */
  const formatTitle = (title) => {
    if (!isValidTitle(title)) return DEFAULT_TITLE;

    let formattedTitle = title;
    if (task?.ProjectTaskId) {
      formattedTitle = `${task?.ProjectTaskId}`;
    }
    return formattedTitle;
  };

  /** If no valid title is provided or useDefaultTitle is true, use the default title */
  if (!isValidTitle(title) || useDefaultTitle) {
    return (
      <Helmet>
        <title>{DEFAULT_TITLE}</title>
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{formatTitle(title)}</title>
    </Helmet>
  );
};

export default React.memo(TitleManager);
